import { playerEventsConstants } from '../../constants/playerConstants';
import { getAffiliate, getBrowserType } from '../../utils/Utils';
import { NPAW_CUSTOM_CONSTANTS, VIDEO_OPTIONS_KEYS } from './npawConstants';

let singlePlayDetails: any = {};
let playerInstance: any = {};

function setSinglePlayDetails(info: any) {
  singlePlayDetails = info;
}

function setPlayerInstance(player: any) {
  playerInstance = player;
}

// CONTENT HELPERS
function getEpisodeTitle() {
  const { assetDetails = {} } = singlePlayDetails || {};
  const episodeTitle =
    assetDetails?.asset_subtype === 'movie'
      ? NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE
      : assetDetails?.title ||
        assetDetails?.original_title ||
        NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  return episodeTitle;
}

function getContentTitle() {
  const { assetDetails = {} } = singlePlayDetails || {};
  const contentTitle =
    assetDetails?.title ||
    assetDetails?.original_title ||
    NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  return contentTitle;
}

function getContentId() {
  const { assetDetails = {} } = singlePlayDetails || {};
  const contentId = assetDetails?.id || NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  return contentId;
}

function getProgramName() {
  return 'null'; // TODO: Implement
}

function getContentDuration() {
  const { assetDetails = {} } = singlePlayDetails || {};
  const contentDuration = assetDetails?.duration || 0;
  return contentDuration;
}

function getUserEmail() {
  return 'null'; // TODO: Implement
}

function getFPS() {
  return 'null'; // TODO: Implement
}

function getBitrate() {
  return 'null'; // TODO: Implement
}

function getTotalBytes() {
  return 'null'; // TODO: Implement
}

function getThroughput() {
  return 'null'; // TODO: Implement
}

function shouldSendTotalBytes() {
  return false; // TODO: Implement
}

export function getRendition() {
  try {
    const qualityLevels = playerInstance?.qualityLevels();
    const activeRendition = Array.from(
      { length: qualityLevels.length },
      (_, i) => qualityLevels[i]
    ).find((l) => l.enabled);
    return activeRendition
      ? `${activeRendition.width}x${activeRendition.height}`
      : NPAW_CUSTOM_CONSTANTS.UNKNOWN;
  } catch (error) {
    return NPAW_CUSTOM_CONSTANTS.UNKNOWN;
  }
}

function getResourceUrl() {
  return 'null'; // TODO: Implement
}

function getCDN() {
  return 'null'; // TODO: Implement
}

function getCDNNode() {
  return 'null'; // TODO: Implement
}

function getCDNType() {
  return 'null'; // TODO: Implement
}

function getStreamingProtocol() {
  try {
    const videoElement = playerInstance?.el?.();
    if (videoElement) {
      const sources = videoElement.querySelectorAll('source');
      for (const source of sources) {
        const src = source.src || source.getAttribute('src');
        if (src) {
          if (src.includes('.mpd')) return NPAW_CUSTOM_CONSTANTS.DASH;
          if (src.includes('.m3u8')) return NPAW_CUSTOM_CONSTANTS.HLS;
        }
      }
      // After checking all sources without finding .mpd or .m3u8
      return NPAW_CUSTOM_CONSTANTS.UNKNOWN;
    } else {
      const browserType = getBrowserType();
      if (browserType === 'Safari') {
        return NPAW_CUSTOM_CONSTANTS.HLS;
      }
      return NPAW_CUSTOM_CONSTANTS.DASH;
    }
  } catch (error) {
    return NPAW_CUSTOM_CONSTANTS.UNKNOWN;
  }
}

function getSagaName() {
  return 'null'; // TODO: Implement
}

function getTVShow() {
  const { showDetails = {} } = singlePlayDetails || {};
  const tvShow =
    showDetails?.title ||
    showDetails?.original_title ||
    NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  return tvShow;
}

function getSeasonNumber() {
  const { showDetails = {} } = singlePlayDetails || {};
  const seasonNumber =
    showDetails?.season || NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  return seasonNumber;
}

function getChannelName() {
  const { assetDetails = {} } = singlePlayDetails || {};
  const channel =
    assetDetails?.asset_type === 9
      ? assetDetails?.original_title
      : NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  return channel;
}

function getImdbId() {
  return 'null'; // TODO: Implement
}

function getGracenoteId() {
  return 'null'; // TODO: Implement
}

function getContentType() {
  const { assetDetails = {} } = singlePlayDetails || {};
  const contentType =
    assetDetails?.asset_subtype || NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  return contentType;
}

function getGenre() {
  const { assetDetails = {} } = singlePlayDetails || {};
  const genres = assetDetails.genres || [];
  if (genres.length === 0) {
    return NPAW_CUSTOM_CONSTANTS.NOT_RECEIVED;
  } else {
    return genres
      .map(
        (channelObj: { id: any; value: any }) =>
          channelObj.id || channelObj.value
      )
      .join(', ');
  }
}

function getLanguage() {
  const { assetDetails = {} } = singlePlayDetails || {};
  const { ordered_audio_languages = [], audio_languages = [] } =
    assetDetails || {};
  const language =
    ordered_audio_languages[0] ||
    audio_languages[0] ||
    NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  return language;
}

export function getSubtitles() {
  let selectedSubtitle = NPAW_CUSTOM_CONSTANTS.NOT_APPLICABLE;
  try {
    const subsActive =
      window.videoPlayer &&
      window.videoPlayer
        .textTracks()
        .tracks_.filter((subs: { mode: string }) => subs.mode === 'showing');
    if (subsActive && subsActive.length > 0) {
      selectedSubtitle = subsActive[0].label;
    }
  } catch (error) {
    return selectedSubtitle;
  }
  return selectedSubtitle;
}

function getContractedResolution() {
  const width = window.screen.width;
  const height = window.screen.height;
  return `${width}x${height}`;
}

function getContentCost() {
  return 'null'; // TODO: Implement
}

function getContentPrice() {
  return 'null'; // TODO: Implement
}

function getPlaybackType() {
  const { entitlement = {} } = singlePlayDetails || {};
  const playbackType = entitlement?.isLive
    ? NPAW_CUSTOM_CONSTANTS.LIVE
    : NPAW_CUSTOM_CONSTANTS.VOD;
  return playbackType;
}

function getDRM() {
  return 'null'; // TODO: Implement
}

// ENCODING HELPERS
function getDeviceName() {
  const ua = navigator.userAgent.toLowerCase();

  if (/windows nt/.test(ua)) return 'PCWindows';
  if (/macintosh|mac os x/.test(ua)) return 'PCMac';
  if (/linux/.test(ua)) return 'PCLinux';

  if (/iphone/.test(ua)) return 'iPhone';
  if (/ipad/.test(ua)) return 'iPad';
  if (/ipod/.test(ua)) return 'iPod';

  if (/android/.test(ua)) {
    if (/mobile/.test(ua)) return 'AndroidPhone';
    return 'AndroidTablet';
  }
  if (/crios|chrome/.test(ua) && /cros/.test(ua)) return 'ChromeOS';
  return NPAW_CUSTOM_CONSTANTS.UNKNOWN;
}

function getConnectionType() {
  try {
    const connection =
      (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;
    return (
      connection.effectiveType.toUpperCase() || NPAW_CUSTOM_CONSTANTS.UNKNOWN
    );
  } catch (error) {
    return NPAW_CUSTOM_CONSTANTS.UNKNOWN;
  }
}

function getPlanId() {
  let planId = sessionStorage.getItem(playerEventsConstants.PLAN_ID);
    planId =
      planId && typeof planId !== 'undefined'
        ? JSON.parse(planId)
        : playerEventsConstants.Not_Applicable;
    return planId;
}

function getCodecSettings() {
  return 'null'; // TODO: Implement
}

function getCodecProfile() {
  return 'null'; // TODO: Implement
}

function getContainerFormat() {
  return 'null'; // TODO: Implement
}

// EXTRA DATA HELPERS
function getTransactionCode() {
  return 'null'; // TODO: Implement
}

function getExtraMetrics() {
  return {}; // TODO: Implement
}

function getExtraMetadata() {
  return {
    [VIDEO_OPTIONS_KEYS.AFFILIATE]: getAffiliate(),
    [VIDEO_OPTIONS_KEYS.PLAN_ID]: getPlanId()
  }; // TODO: Implement
}

// MAIN EXPORT
export function getNpawVideoOptions(player?: any, singlePlayDetails?: any) {
  setSinglePlayDetails(singlePlayDetails || {});
  setPlayerInstance(player || {});
  return {
    [VIDEO_OPTIONS_KEYS.EPISODE_TITLE]: getEpisodeTitle(),
    [VIDEO_OPTIONS_KEYS.TITLE]: `${getContentId()} - ${getContentTitle()}`,
    [VIDEO_OPTIONS_KEYS.ID]: getContentId(),
    [VIDEO_OPTIONS_KEYS.PLATFORM_NAME]: getDeviceName(),
    [VIDEO_OPTIONS_KEYS.DEVICE_CODE]: getDeviceName(),
    [VIDEO_OPTIONS_KEYS.CONNECTION_TYPE]: getConnectionType(),
    [VIDEO_OPTIONS_KEYS.DURATION]: getContentDuration(),
    [VIDEO_OPTIONS_KEYS.IS_LIVE]:
      getPlaybackType() === NPAW_CUSTOM_CONSTANTS.LIVE,
    [VIDEO_OPTIONS_KEYS.STREAMING_PROTOCOL]: getStreamingProtocol(),
    [VIDEO_OPTIONS_KEYS.TV_SHOW]: getTVShow(),
    [VIDEO_OPTIONS_KEYS.SEASON]: getSeasonNumber(),
    [VIDEO_OPTIONS_KEYS.CHANNEL]: getChannelName(),
    [VIDEO_OPTIONS_KEYS.TYPE]: getContentType(),
    [VIDEO_OPTIONS_KEYS.GENRE]: getGenre(),
    [VIDEO_OPTIONS_KEYS.LANGUAGE]: getLanguage(),
    [VIDEO_OPTIONS_KEYS.CONTRACTED_RESOLUTION]: getContractedResolution(),
    [VIDEO_OPTIONS_KEYS.PLAYBACK_TYPE]: getPlaybackType(),
    [VIDEO_OPTIONS_KEYS.METADATA]: getExtraMetadata()
  };
}
